import { Link } from "react-router-dom";
import { WORKSPACE_HOME_PATH } from "../../app/routes/navigationPaths";

export default function NotFoundPage({ authenticated = false }) {
  return (
    <div className="min-h-full bg-slate-50 p-6">
      <div className="mx-auto max-w-lg rounded-lg border bg-white p-6">
        <h1 className="text-xl font-semibold text-slate-900">Page not found</h1>
        <p className="mt-2 text-sm text-slate-600">
          This link may be outdated or the address may be incorrect.
        </p>
        <div className="mt-5 flex gap-4">
          {authenticated && <Link className="font-semibold text-emerald-700 underline" to={WORKSPACE_HOME_PATH}>Go to workspace</Link>}
          <Link className="font-semibold text-emerald-700 underline" to="/login">Go to sign in</Link>
        </div>
      </div>
    </div>
  );
}
